// Generated by ReScript, PLEASE EDIT WITH CARE


function t_decode(v) {
  return {
          TAG: /* Ok */0,
          _0: v
        };
}

export {
  t_decode ,
}
/* No side effect */
